import { type FC, forwardRef } from 'react';
import Checkbox from '../Checkbox';
import { type CardCheckboxPropTypes, type CardCheckboxTheme } from '../types/propsType';
import { Theme } from '../../types/enums';
import { NextgenImage } from '../../NextgenImage/NextgenImage';
import styles from './CardCheckbox.module.scss';

const CardCheckbox: FC<CardCheckboxPropTypes> = forwardRef<HTMLLabelElement, CardCheckboxPropTypes>(
  ({ id, text, subText, imgSrc, disabled, checked, theme = Theme.BLACK, imageShadows = false, ...restProps }, ref) => (
    <label
      className={`${styles['cardcheckbox']} ${styles[theme]} ${disabled ? styles['disabled'] : ''}`}
      ref={ref}
      htmlFor={`checkbox-${id}-${text}`}
      data-testid="cardCheckbox-testid"
    >
      <section
        className={
          imageShadows
            ? `${styles['cardcheckbox-body']} ${styles['cardcheckbox-body-imageShadows']}`
            : styles['cardcheckbox-body']
        }
      >
        {imgSrc && (
          <>
            {imageShadows ? (
              <>
                <div className={`${styles['cardcheckbox-body-image']} ${styles['cardcheckbox-body-image-shadows']}`}>
                  <NextgenImage src={imgSrc} alt="card" />
                </div>
                <div
                  data-testid="image-shadow-testid"
                  className={`${styles['cardcheckbox-body-image-shadow']} ${styles['cardcheckbox-body-image-shadow1']}`}
                ></div>
                <div
                  className={`${styles['cardcheckbox-body-image-shadow']} ${styles['cardcheckbox-body-image-shadow2']}`}
                ></div>
              </>
            ) : (
              <div className={styles['cardcheckbox-body-image']}>
                <NextgenImage src={imgSrc} alt="card" />
              </div>
            )}
          </>
        )}
        <section className={styles['cardcheckbox-body-main']}>
          {text && <p className={styles['cardcheckbox-body-text']}>{text}</p>}
          {subText && <p className={styles['cardcheckbox-body-subtext']}>{subText}</p>}
        </section>
      </section>
      <section>
        <Checkbox text="" disabled={disabled} theme={theme} checked={checked} {...restProps} id={id} />
      </section>
    </label>
  ),
);
CardCheckbox.displayName = 'CardCheckbox';
export default CardCheckbox;
export type { CardCheckboxTheme };
